import React from 'react';

import { DeleteIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';
import { useTranslation } from 'react-i18next';

import type { DeleteCardsProps } from '../types';
import { useDeleteCardsWithConfirmation } from './useDeleteCardsWithConfirmation';

interface DeleteCardsButtonProps extends
  DeleteCardsProps,
  ButtonProps {}

function DeleteCardsButton({
  cardIds,
  className = undefined,
  onDeleteCards = undefined,
  'data-testid': dataTestId = 'deletePersonButton',
  ...props
}: DeleteCardsButtonProps): React.JSX.Element {
  const { t } = useTranslation();
  const deleteCardsHandler = useDeleteCardsWithConfirmation({
    cardIds,
  });

  return (
    <Control.Button
      className={className}
      data-testid={dataTestId}
      icon={<DeleteIcon />}
      kind="negative"
      onClick={async () => {
        await deleteCardsHandler?.();
        onDeleteCards?.();
      }}
      size="medium"
      variant="flat"
      {...props}
    >
      {t('features:deletePerson.button')}
    </Control.Button>
  );
}

export { DeleteCardsButton };
